module.exports = __webpack_public_path__ + "img/bsnl.29e1a62c.png";